module.exports = __webpack_public_path__ + "static/media/before.17ef1f43.png";